import type { MarqueeLocationStatus } from '@/features/marquee/types'
import { locationStatusToLabelKey } from '@/features/marquee/utils'
import { cn } from '@/helpers/utils'
import { useTranslation } from '@/translations/i18n'

const STATUS_STYLES = {
	active: 'bg-green-200 text-green-700',
	deactivated: 'bg-red-100 text-red-800'
} as const satisfies Record<MarqueeLocationStatus, string>

interface LocationStatusBadgeProps {
	status: MarqueeLocationStatus
	className?: string
}

/** The Locations table's status pill, same shape as the Team one. */
export function LocationStatusBadge({
	status,
	className
}: LocationStatusBadgeProps) {
	const { t } = useTranslation()
	return (
		<span
			className={cn(
				'inline-flex items-center whitespace-nowrap rounded-full px-3 py-1.5 font-medium text-xs uppercase',
				STATUS_STYLES[status],
				className
			)}
		>
			{t(locationStatusToLabelKey[status])}
		</span>
	)
}
